export { default } from "./ItemClassDetail";

